exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* EDITED ORIGINAL VERSION */\n.jvectormap-label {\n    position: absolute;\n    display: none;\n    border-radius: 3px;\n    background: #292929;\n    color: white;\n    font-size: smaller;\n    padding: 3px;\n}\n.jvectormap-zoomin, \n.jvectormap-zoomout {\n    position: absolute;\n    left: 10px;\n    background: #fff;\n    border: 1px solid #e1e1e1;\n    color: #3498db;\n    cursor: pointer;\n    text-align: center;\n    height: 24px;\n    line-height: 24px;\n    width: 24px;\n    font-size: 0.75em;\n}\n.jvectormap-zoomin {\n    top: 10px;\n    border-radius: 3px 3px 0 0;\n}\n.jvectormap-zoomout {\n    top: 33px;\n    border-radius: 0 0 3px 3px;\n}\n.jvectormap-zoomin:hover, \n.jvectormap-zoomout:hover {\n\tbackground-color: #eeeeee;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--3-2!../css/libs/jquery-jvectormap-1.2.2.css
// module id = 2786
// module chunks = 11